export interface ReviewCandidate {
  id: string;
  title: string;
  text: string;
  source?: string;
}

export interface AnonymousCandidate {
  anonymousId: string;
  label: '文本 A' | '文本 B';
  text: string;
}

export interface RubricScores {
  hook: number;
  causality: number;
  character: number;
  devices: number;
  producibility: number;
}

export type BlindWinner = 'A' | 'B' | 'tie' | 'abstain';

export interface BlindVote {
  reviewId: string;
  winner: BlindWinner;
  scores: RubricScores;
  total: number;
  note: string;
  recordedAt: string;
}

function stableHash(value: string): number {
  let hash = 2166136261;
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}

export function anonymizePair(
  first: ReviewCandidate,
  second: ReviewCandidate,
  reviewSeed: string,
): AnonymousCandidate[] {
  const ordered = stableHash(reviewSeed) % 2 === 0 ? [first, second] : [second, first];
  return ordered.map((candidate, index) => ({
    anonymousId: `candidate-${stableHash(`${reviewSeed}:${candidate.id}`).toString(36)}`,
    label: index === 0 ? '文本 A' : '文本 B',
    text: candidate.text,
  }));
}

export function rubricTotal(scores: RubricScores): number {
  return Object.values(scores).reduce((sum, score) => sum + Math.max(1, Math.min(5, score)), 0);
}

export function createBlindVote(
  reviewId: string,
  winner: BlindWinner,
  scores: RubricScores,
  note: string,
): BlindVote {
  return {
    reviewId,
    winner,
    scores,
    total: rubricTotal(scores),
    note: note.trim(),
    recordedAt: new Date().toISOString(),
  };
}
